import { render, staticRenderFns } from "./not-editable.vue?vue&type=template&id=065c83b0&scoped=true&"
import script from "./not-editable.vue?vue&type=script&lang=js&"
export * from "./not-editable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c83b0",
  null
  
)

export default component.exports